import styled from '@emotion/styled';

export const AllStakesWrapper = styled('li', { label: 'AllStakesWrapper' })`
    margin-top: 16px;
`;
